import React from "react";
import { BaseLayout } from "../components/baseLayout";

function Bills() {
  return (
    <BaseLayout>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Bills paid</h4>
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead className="table table-head">
                    <tr>
                      <th>Date</th>
                      <th>Period</th>
                      <th>Price</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>August 12, 2022</td>
                      <td>64 hours</td>
                      <td className="text-success">
                        {" "}
                        $200.000 <i className="mdi mdi-cash"></i>
                      </td>
                      <td>
                        <label className="badge badge-success">Completed</label>
                      </td>
                    </tr>
                    <tr>
                      <td>October 12, 2022</td>
                      <td>32 hours</td>
                      <td className="text-success">
                        {" "}
                        $200.000 <i className="mdi mdi-cash"></i>
                      </td>
                      <td>
                        <label className="badge badge-success">Completed</label>
                      </td>
                    </tr>
                    <tr>
                      <td>November 12, 2022</td>
                      <td>32 hours</td>
                      <td className="text-success">
                        {" "}
                        $200.000 <i className="mdi mdi-cash"></i>
                      </td>
                      <td>
                        <label className="badge badge-success">Completed</label>
                      </td>
                    </tr>
                    <tr>
                      <td>December 12, 2022</td>
                      <td>32 hours</td>
                      <td className="text-success">
                        {" "}
                        $200.000 <i className="mdi mdi-cash"></i>
                      </td>
                      <td>
                        <label className="badge badge-success">Completed</label>
                      </td>
                    </tr>
                    <tr>
                      <td>January 12, 2023</td>
                      <td>32 hours</td>
                      <td className="text-success">
                        {" "}
                        $200.000 <i className="mdi mdi-cash"></i>
                      </td>
                      <td>
                        <label className="badge badge-warning">
                          In progress
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BaseLayout>
  );
}

export { Bills };
